import { render, staticRenderFns } from "./Dataset_immune_grid.vue?vue&type=template&id=3ec41935&scoped=true&"
import script from "./Dataset_immune_grid.vue?vue&type=script&lang=js&"
export * from "./Dataset_immune_grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec41935",
  null
  
)

export default component.exports